import { DotTypes } from "../types";

export default {
  dots: "dots",
  rounded: "rounded",
  classy: "classy",
  classyRounded: "classy-rounded",
  square: "square",
  extraRounded: "extra-rounded",
  rhombus: "rhombus",
  smallSquare: "small-square",
  smallDots: "small-dots",
  randomDots: "random-dots",
  dotsHorizontal: "dots-horizontal",
  dotsVertical: "dots-vertical",
  rhombusVertical: "rhombus-vertical",
  squareStripe: "square-stripe",
  roundedStripe: "rounded-stripe",
  random: "random"
} as DotTypes;
